<template>
	<div :class="`landing-footer_${textColor}`" class="landing-footer">
		<p v-if="description">
			{{ description }}
		</p>
		<p>
			{{ disclaimer ?? $t('landing_male.results_disclaimer') }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'LandingFooter',

	props: {
		description: {
			type: String,
			default: null,
		},

		disclaimer: {
			type: String,
			default: null,
		},

		textColor: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'white'].includes(value),
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-footer {
	margin-top: var(--size-24);

	font-size: var(--size-14);
	line-height: var(--size-20);

	color: var(--Text-Primary-60);

	& p {
		margin: 0 0 var(--size-24);
	}

	&_primary {
		color: var(--Text-Primary-60);
	}

	&_white {
		color: var(--Text-White-60);
	}
}
</style>
